<template>
  <img
    class="img-fluid"
    alt="nft image"
    v-show="isImageLoaded"
    :src="getImgUrl(img)"
    @load="loaded"
    @error="replaceByDefault(index)"
  />
  <img
    v-if="!isImageLoaded && !imageFailed"
    class="loading w-100"
    :src="'/images/loader.gif'"
  />
  <img v-if="imageFailed" class="img-fluid" :src="getDefault()" />
</template>

<script>
import ApiService from "@/services";
export default {
  name: "ImgBlock",
  props: ["img", "link", "defaultLink"],
  data() {
    return {
      isImageLoaded: false,
      imageFailed: false,
    };
  },
  methods: {
    loaded() {
      this.isImageLoaded = true;
    },
    replaceByDefault() {
      this.imageFailed = true;
    },
    getDefault() {
      if (this.defaultLink) {
        return this.defaultLink;
      } else {
        return "/images/loader.gif";
      }
    },
    getImgUrl(imgHash) {
      if (this.link == true) {
        return ApiService.getImgUrl(imgHash);
      } else {
        return imgHash;
      }
    },
  },
};
</script>
<style scoped>
.multiple_cards .main_cardframe a img {
  height: 100%;
  /* padding: 5px 8px; */
  /* border-radius: 20px; */
}
.main_cardframe a img {
  height: 100%;
  width: 100%;
  padding: 2px 5px;
  border-radius: 14px;
}
.main_cardframe a img {
  height: 100%;
  width: 100%;
  padding: 2px 5px;
  border-radius: 14px;
}
</style>
